import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PolicyService } from 'src/app/modules/policy/policy.service';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { IFormKey } from '../../models/forms';
import { premium_payment_form_group_config } from './premium-payment-reactivation.constants';

@Component({
  selector: 'app-premium-payment-reactivation',
  templateUrl: './premium-payment-reactivation.component.html',
  styleUrl: './premium-payment-reactivation.component.scss',
})
export class PremiumPaymentReactivationComponent {
  @Input({ required: true }) form: FormGroup;

  public keys: IFormKey[];

  constructor(private _policyService: PolicyService) {}

  ngOnInit(): void {
    if (this.isPolicyPrevidenziale) {
      this.keys = CommonUtils.assign(premium_payment_form_group_config);
    }
  }

  get isPolicyPrevidenziale(): boolean {
    return this._policyService.isDetailPrevidenziale;
  }
}
